import { render, staticRenderFns } from "./edit-inboxes.vue?vue&type=template&id=15435303&scoped=true&"
import script from "./edit-inboxes.vue?vue&type=script&lang=js&"
export * from "./edit-inboxes.vue?vue&type=script&lang=js&"
import style0 from "./edit-inboxes.vue?vue&type=style&index=0&id=15435303&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15435303",
  null
  
)

export default component.exports